import React, { useEffect } from 'react';
import { notification } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faCircleInfo,
  faOctagonExclamation,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import theme from '@css/theme';

const iconMap = {
  error: <FontAwesomeIcon icon={faOctagonExclamation} color={theme.token.colorError} />,
  success: <FontAwesomeIcon icon={faCircleCheck} color={theme.token.colorSuccess} />,
  warning: <FontAwesomeIcon icon={faTriangleExclamation} color={theme.token.colorWarning} />,
  info: <FontAwesomeIcon icon={faCircleInfo} color={theme.token.colorInfo} />,
};

type NotificationType = 'success' | 'error' | 'info' | 'warning';

interface ToastProps {
  type: NotificationType;
  onClose?: () => void;
  message: React.ReactNode;
  duration?: number;
  destroyOnUnmount?: boolean;
}

export const Toast: React.FC<ToastProps> = ({
  type,
  onClose,
  message,
  duration = 4.5,
  destroyOnUnmount = false,
}) => {
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    if (message) {
      api[type]({
        icon: iconMap[type],
        message,
        duration,
        placement: 'top',
        className: `notification ${type}-notification`,
        onClose,
      });
    }
  }, [message]);

  useEffect(
    () => () => {
      if (destroyOnUnmount) {
        api.destroy();
      }
    },
    [],
  );

  return <div>{contextHolder}</div>;
};
